<mat-drawer-container autosize>
  <mat-drawer-content style="width:100%;">

    <div class="container thin-scrollbar">
      @if(evaluationsList){
      <mat-card appearance="raised" class="card-container">
        <div class="actions-bard-container fx-direction-row fx-wrap fx-between-center fx-gap-5">
          <!-- @if(permToCreate){
          <button mat-raised-button color="primary" matTooltip="Ajouter une évaluation">
            <mat-icon>add</mat-icon>
            <span>Ajouter</span>
          </button>
          } -->
          @if(!isMobile){
          <mat-button-toggle-group [(ngModel)]="tableView" color="accent" aria-label="Vue">
            <mat-button-toggle [value]="false"><mat-icon>view_module</mat-icon> Cartes</mat-button-toggle>
            <mat-button-toggle [value]="true"><mat-icon>table_chart</mat-icon> Tableau</mat-button-toggle>
          </mat-button-toggle-group>
          }@else {
          <span></span>
          }
          @if(!filterSettings.opened){
          <button mat-icon-button [color]="hasActiveFilters() ? 'accent' : ''" (click)="toggleOptions()">
            @if(hasActiveFilters()){
            <mat-icon color="accent" matTooltip="Filtres actifs">filter_alt</mat-icon>
            }@else {
            <mat-icon matTooltip="Filtres inactifs">filter_alt_off</mat-icon>
            }
          </button>
          }
        </div>

        @switch(tableView) {
        @case(false) {
        <app-evaluation-card-view [idEnseignant]="idEnseignant" [evaluations]="filteredEvaluations"
          [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex" [totalItems]="totalItems"
          (deleteEvaluation)="deleteEvaluation($event)" (pageChange)="pageChange($event)" />
        }
        @case(true) {
        <app-evaluation-table-view [idEnseignant]="idEnseignant" [evaluations]="filteredEvaluations"
          [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex" [totalItems]="totalItems"
          (deleteEvaluation)="deleteEvaluation($event)" (pageChange)="pageChange($event)" />
        }
        }

      </mat-card>
      }@else {
      <app-loader message="Chargement des données..." class="margin"></app-loader>
      }

    </div>
  </mat-drawer-content>

  <!-- Filtres -->
  <mat-drawer id="previewDrawer" class="mat-elevation-z1 thin-scrollbar" position="end" [mode]="filterSettings.mode"
    [(opened)]="filterSettings.opened">
    <mat-toolbar class="preview-header fx-direction-row fx-start-center" color='primary'>
      <button mat-icon-button (click)="closeDrawer()" style="margin-right: 3px;">
        <mat-icon>close</mat-icon>
      </button>
      <span>Filtres</span>
    </mat-toolbar>
    <div class="container-fields-filter fx-direction-col">

      <mat-form-field class="field-filter">
        <mat-label>Filtrer par numéro</mat-label>
        <input matInput [(ngModel)]="numFilter " (keyup)="onNumFilterChange($event)" #numInput>
      </mat-form-field>
      <mat-form-field class="field-filter">
        <mat-label>Filtrer par libelle</mat-label>
        <input matInput [(ngModel)]="libelleFilter" (keyup)="onLibelleFilterChange($event)" #libelleInput>
      </mat-form-field>
      <mat-form-field class="field-filter">
        <mat-label>Filtrer par discipline</mat-label>
        <input matInput [(ngModel)]="disciplineFilter " (keyup)="onDisciplineFilterChange($event)" #discInput>
      </mat-form-field>
      <mat-form-field class="field-filter">
        <mat-label>Filtrer par cours</mat-label>
        <input matInput [(ngModel)]="coursFilter " (keyup)="onCoursFilterChange($event)" #coursInput>
      </mat-form-field>
      <div class="fx-direction-row fx-gap-2 field-filter">
        <mat-form-field>
          <mat-label>Du</mat-label>
          <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate"
            (dateChange)="onDateRangeFilterChange()">
          <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>au</mat-label>
          <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" (dateChange)="onDateRangeFilterChange()">
          <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
      </div>
      <!-- @if (hasActiveFilters()) {
      <button mat-button color="warn" (click)="resetFilters()">
        <mat-icon>close</mat-icon>
        Réinitialiser les filtres
      </button>
      } -->
    </div>
    @if (hasActiveFilters()) {
    <div class="drawer-footer">
      <button mat-button color="warn" (click)="resetFilters()" class="btn-reset">
        <mat-icon>close</mat-icon>
        Réinitialiser les filtres
      </button>
    </div>
    }
  </mat-drawer>
</mat-drawer-container>